import { sInputKeyValidationHelper, sIsValidCarReg, sGetFromEngagementTools } from '../../shared.min.js';

const vehicleStatusChecker = {
	tabSection: null,
	motTabContent: null,
	taxTabContent: null,

	motRegField: null,
	motRegInput: null,
	regForm: null,
	submitRegButton: null,

	motApiUrl: null,
	taxApiUrl: null,
	apiSubKey: null,

	vehicleDetailsSection: null,
	vehicleReg: null,
	vehicleDetails: null,
	resetAppButton: null,

	enterCarRegistrationNumber: null,
	registrationValueError: null,
	vehicleNotFound: null,
	taxNotFound: null,
	motNotFound: null,

	isLoading: false,

	init: () => {
		// FORM LABELS FORM THE CMS
		vehicleStatusChecker.getFormLabels();

		//FORM & INPUT NODES
		vehicleStatusChecker.getFormAndInputNodes();
		//TABS
		vehicleStatusChecker.getTabSectionNodes();
		//API NODES
		vehicleStatusChecker.getApiNodes();

		vehicleStatusChecker.getVehicleDetailsSection();

		//E-LISTENERS

		sInputKeyValidationHelper(vehicleStatusChecker.motRegInput, 'alphaNumeric', vehicleStatusChecker.motRegField);

		vehicleStatusChecker.regForm?.addEventListener('submit', e =>
			vehicleStatusChecker.checkRegInput(e, vehicleStatusChecker.motRegInput)
		);
		if (vehicleStatusChecker.vehicleDetailsSection)
			vehicleStatusChecker.resetAppButton?.addEventListener('click', vehicleStatusChecker.resetApp);
	},

	getFormLabels: () => {
		vehicleStatusChecker.enterCarRegistrationNumber =
			document.getElementById('enter-car-registration-number')?.innerText ?? '';
		vehicleStatusChecker.registrationValueError =
			document.getElementById('registration-validation-error')?.innerText ?? '';
		vehicleStatusChecker.vehicleNotFound = document.getElementById('vehicle-not-found')?.innerText ?? '';

		vehicleStatusChecker.taxNotFound = document.getElementById('no-tax-information-found')?.innerText ?? '';
		vehicleStatusChecker.motNotFound = document.getElementById('no-mot-information-found')?.innerText ?? '';
	},

	getFormAndInputNodes: () => {
		vehicleStatusChecker.regForm = document.getElementById('cnfsd-vsc-form');
		vehicleStatusChecker.motRegInput = document.getElementById('cnfsd-vsc-reg');
		vehicleStatusChecker.motRegField = vehicleStatusChecker.motRegInput.closest('fieldset.field-group');
		vehicleStatusChecker.submitRegButton = document.getElementById('cnfsd-vsc-submit-reg');
	},

	getTabSectionNodes: () => {
		vehicleStatusChecker.tabSection = document.getElementById('cnfsd-vsc-car-tabs');
		vehicleStatusChecker.motTabContent = document.getElementById('cnfsd-vsc-mot-tab');
		vehicleStatusChecker.taxTabContent = document.getElementById('cnfsd-vsc-tax-tab');
	},

	getApiNodes: () => {
		const motEndPointNode = document.getElementById('mot-api-endpoint');
		const taxEndPointNode = document.getElementById('tax-api-endpoint');
		const subKeyNode = document.getElementById('sub-key');

		vehicleStatusChecker.motApiUrl = motEndPointNode
			? motEndPointNode.textContent
			: 'http://localhost:3000/vehicle-lookup/mot?registrationNumber';
		vehicleStatusChecker.taxApiUrl = taxEndPointNode
			? taxEndPointNode.textContent
			: 'http://localhost:3000/vehicle-lookup/tax?registrationNumber';
		vehicleStatusChecker.apiSubKey = subKeyNode ? subKeyNode.textContent : '';

		if (!motEndPointNode || !subKeyNode || !taxEndPointNode)
			console.error(
				'Missing endpoint HTML node(s) with ids of mot-api-endpoint, tax-api-endpoint, or sub-key. Ignore if in dev mode'
			);
	},

	getVehicleDetailsSection: () => {
		vehicleStatusChecker.vehicleDetailsSection = document.getElementById('cnfsd-vsc-vehicle-details');
		vehicleStatusChecker.vehicleReg = document.getElementById('cnfsd-vsc-vehicle-details__reg');
		vehicleStatusChecker.vehicleDetails = document.getElementById('cnfsd-vsc-vehicle-details__details');
		vehicleStatusChecker.resetAppButton = document.getElementById('cnfsd-vsc-vehicle-details__reset');
	},

	validateRegInput: motRegInputValue => {
		const errorMessages = {
			empty: vehicleStatusChecker.enterCarRegistrationNumber,
			tooShort: vehicleStatusChecker.vehicleNotFound,
			tooLong: vehicleStatusChecker.vehicleNotFound,
			invalidFormat: vehicleStatusChecker.vehicleNotFound,
		};

		const { isValid, errorMessage } = sIsValidCarReg(motRegInputValue, errorMessages);
		if (!isValid) return errorMessage;
	},

	removeRegErrorMessage: (e, messageNode, field) => {
		const key = e.keyCode || e.which || e.key;
		if (key === 'Enter' || key === 13) {
			e.preventDefault();
			return false;
		}

		messageNode.innerText = '';
		field.classList.remove('field-group--error');
	},

	displayRegErrorMessage: (errorMessage, input) => {
		vehicleStatusChecker.motRegField.classList.add('field-group--error');

		const errorMessageNode = vehicleStatusChecker.motRegField.querySelector('.error-message');
		errorMessageNode.innerText = errorMessage;

		input.addEventListener('keyup', e =>
			vehicleStatusChecker.removeRegErrorMessage(e, errorMessageNode, vehicleStatusChecker.motRegField)
		);
	},

	carRegNotFound: () => {
		const errorMessage = vehicleStatusChecker.registrationValueError;
		vehicleStatusChecker.displayRegErrorMessage(errorMessage, vehicleStatusChecker.motRegInput);
	},

	checkRegInput: (e, input) => {
		e.preventDefault();

		//IF BUTTON IS IN PROCESS OF BEING CLICKED, STOP ADDITIONAL CLICKS
		if (vehicleStatusChecker.isLoading) return;

		vehicleStatusChecker.submitRegButton.classList.add('btn--loading');
		vehicleStatusChecker.isLoading = true;

		const formErrorMessage = vehicleStatusChecker.validateRegInput(input.value);

		if (formErrorMessage) {
			vehicleStatusChecker.displayRegErrorMessage(formErrorMessage, input);
			vehicleStatusChecker.isLoading = false;
			vehicleStatusChecker.submitRegButton.classList.remove('btn--loading');
		} else {
			const inputWithoutSpaces = input.value.replaceAll(' ', '');
			vehicleStatusChecker.fetchVehicleData(inputWithoutSpaces);
		}
	},

	toggleUiVisibilityHelper: element => {
		element.classList.contains('display-none')
			? element.classList.remove('display-none')
			: element.classList.add('display-none');
	},

	showResultsNotFound: (tabSection, notFoundText) => {
		//MOT TESTS DON'T EXIST
		const blockQuote = document.createElement('div');
		const blockQuoteTitle = document.createElement('div');
		blockQuote.classList.add('mod-blockquote', 'bg-product--primary', 'mod-blockquote--fail');

		blockQuoteTitle.classList.add('mod-blockquote__title');
		blockQuoteTitle.textContent = `${notFoundText}`;
		blockQuote.appendChild(blockQuoteTitle);
		tabSection.appendChild(blockQuote);
	},

	organiseMotResults: motTests => {
		motTests.sort((a, b) => new Date(b.completedDate) - new Date(a.completedDate));

		const motTestsByYear = {};
		motTests.forEach(motTest => {
			const motDate = new Date(motTest.completedDate);
			const motTestYear = motDate.getUTCFullYear();

			//YEAR DOES EXIST IN MOT TESTS OBJ
			if (motTestsByYear.hasOwnProperty(motTestYear)) {
				motTestsByYear[motTestYear].push(motTest);
			} else {
				motTestsByYear[motTestYear] = [motTest];
			}
		});

		vehicleStatusChecker.populateMotTab(motTestsByYear);
	},

	toggleAccordionContent: (itemContainer, question, answer) => {
		const accordionExpanded = question.classList.contains('active');
		accordionExpanded
			? vehicleStatusChecker.closeAccordion(itemContainer, question, answer)
			: vehicleStatusChecker.openAccordion(itemContainer, question, answer);
	},

	openAccordion: (itemContainer, question, answer) => {
		answer.style.display = 'block';
		itemContainer.classList.add('open');
		question.classList.add('active');
	},

	closeAccordion: (itemContainer, question, answer) => {
		question.classList.remove('active');
		itemContainer.classList.remove('open');
		answer.style.display = 'none';
	},

	createAccordionMarkup: (questionText, accordionContent) => {
		const itemContainer = document.createElement('div');
		itemContainer.classList.add('mod-accordion__item');

		const question = document.createElement('h3');
		question.classList.add('mod-accordion__question');

		const questionLink = document.createElement('span');
		questionLink.classList.add('mod-accordion__link', 'constrain');

		const underline = document.createElement('span');
		underline.classList.add('mod-accordion__underline');
		underline.textContent = questionText;

		const modRowDiv = document.createElement('div');
		modRowDiv.classList.add('mod-row');
		modRowDiv.style.display = 'none';

		const modRowContainerDiv = document.createElement('div');
		modRowContainerDiv.classList.add('mod-row__container');

		//APPEND QUESTION TO ACCORDION ITEM
		questionLink.appendChild(underline);
		question.appendChild(questionLink);
		itemContainer.appendChild(question);

		//APPEND CONTENT TO ACCORDION ITEM
		modRowContainerDiv.appendChild(accordionContent);
		modRowDiv.appendChild(modRowContainerDiv);
		itemContainer.appendChild(modRowDiv);

		return itemContainer;
	},

	organiseMotComments: comments => {
		const failComments = [];
		const advisoryComments = [];
		comments &&
			comments.forEach(comment => {
				if (comment.type.toLowerCase() === 'advisory') {
					advisoryComments.push(comment.text);
				} else {
					failComments.push(comment.text);
				}
			});

		return [failComments, advisoryComments];
	},

	formatDate: (date, isYearOnly) => {
		const day = date.getUTCDate();
		const month = date.getUTCMonth() + 1;
		const year = date.getUTCFullYear();

		if (isYearOnly) return year;

		const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;

		return formattedDate;
	},

	parseDateTime: dateTime => {
		const hasTime = dateTime.includes(':');

		let parsedDateTime = dateTime.replace(/\./g, '-');

		//CHECKS IF DATETIME HAS TIME SECTION AND IF NOT, ADD IT
		if (hasTime) {
			parsedDateTime = `${parsedDateTime.replace(' ', 'T')}Z`;
		} else {
			parsedDateTime += 'T00:00:00Z';
		}

		return parsedDateTime;
	},

	populateMotAccordions: (year, motTestsByYear) => {
		//CREATE ACCORDION MARKUP
		const accordionContentContainer = document.createElement('div');
		accordionContentContainer.classList.add('mod-accordion__content');

		//LOOP THROUGH EACH MOT TEST AND CREATE AN ACCORDION BOX FOR EACH ONE
		motTestsByYear[year].forEach(motTest => {
			const { testResult, completedDate, odometerValue, defects } = motTest;

			const resultBox = document.createElement('div');
			resultBox.classList.add('result-box');

			//FORMAT DATA
			const [failComments, advisoryComments] = vehicleStatusChecker.organiseMotComments(defects);

			const formattedDate = vehicleStatusChecker.formatDate(new Date(completedDate));

			resultBox.innerHTML = `
                <div class="result-box__title ${testResult.toLowerCase() === 'passed' ? 'result-box__title--pass' : 'result-box__title--fail'}">
                        ${testResult.toLowerCase()}
                    </div>
                <ul>
                    ${formattedDate ? `<li>Date <b>${formattedDate}</b></li>` : ''}
                    ${odometerValue ? `<li>Mileage <b>${parseFloat(odometerValue).toLocaleString()}</b></li>` : ''}

                    ${
						advisoryComments.length
							? `<li>
                        <div>Advisory notices</div>
                        <div><b>${advisoryComments.join('. ')}</b></div>
                    </li>`
							: '<li><div>Advisory notices</div><b>None</b><div>'
					}     
                    ${
						failComments.length
							? `<li>
                        <div>Fail notices</div>
                        <div><b>${failComments.join('. ')}</b></div>
                    </li>`
							: ''
					}
                </ul>
            `;

			//ADD EACH ACCORDION BOX TO THE CONTENT CONTAINER
			accordionContentContainer.appendChild(resultBox);
		});

		const accordionScaffold = vehicleStatusChecker.createAccordionMarkup(year, accordionContentContainer);
		return accordionScaffold;
	},

	populateMotQuoteBox: motTestsByYear => {
		const latestTestWithExpiryDate = {};

		for (const year in motTestsByYear) {
			const motTestPassed = motTestsByYear[year].filter(
				motTest => motTest.expiryDate !== '' && motTest.expiryDate !== undefined
			);

			if (motTestPassed.length) latestTestWithExpiryDate['latestTest'] = motTestPassed[0];
		}

		let latestExpiryDate = '';

		if (
			latestTestWithExpiryDate &&
			latestTestWithExpiryDate.latestTest &&
			latestTestWithExpiryDate.latestTest.expiryDate
		) {
			latestExpiryDate = latestTestWithExpiryDate.latestTest.expiryDate;
		}

		const parsedExpiryDate = new Date(latestExpiryDate);
		const formattedExpiryDate = vehicleStatusChecker.formatDate(parsedExpiryDate);
		const today = new Date();

		const motBoxHTML = `
                ${
					parsedExpiryDate > today
						? `<div class="mod-blockquote mod-blockquote--pass bg-product--primary"><div class="mod-blockquote__title">MOT currently valid</div><span>Expires: <b>${formattedExpiryDate}</b></span></div>`
						: `<div class="mod-blockquote mod-blockquote--fail bg-product--primary"><div class="mod-blockquote__title">No valid MOT</div><span>Expired: <b>${latestExpiryDate ? formattedExpiryDate : '-'}</b></span></div>`
				}
            </div>
        `;
		return motBoxHTML;
	},

	populateTaxQuoteBox: (taxStatus, taxDueDate) => {
		const parsedDateTime = vehicleStatusChecker.parseDateTime(taxDueDate);
		const formattedDate = vehicleStatusChecker.formatDate(new Date(parsedDateTime));

		const fragment = document.createRange().createContextualFragment(
			`
            ${
				taxStatus === 'Taxed'
					? `
                    <div class="mod-blockquote mod-blockquote--pass bg-product--primary">
                        <div class="mod-blockquote__title">Tax currently valid</div>

                        <span>Expires: <b>${formattedDate}</b></span>
                    </div>`
					: `
                    <div class="mod-blockquote mod-blockquote--fail bg-product--primary">
                        <div class="mod-blockquote__title">Tax not valid</div>

                        ${taxStatus !== 'SORN' ? `<span>Expired: <b>${formattedDate}</b>` : ''}
                        </span><span>Sorn: <b>${taxStatus === 'SORN' ? 'Yes' : 'No'}</b></div>
                `
			}
            `
		);

		vehicleStatusChecker.taxTabContent.appendChild(fragment);
	},

	populateMotTab: motTestsByYear => {
		const sortedTests = Object.keys(motTestsByYear).sort((a, b) => parseInt(b) - parseInt(a));

		// Get HTML string for MOT quote box
		const motBoxHTML = vehicleStatusChecker.populateMotQuoteBox(motTestsByYear);

		// Get HTML strings for MOT accordions and join them
		const accordionHTML = sortedTests
			.map(key => {
				const content = vehicleStatusChecker.populateMotAccordions(key, motTestsByYear);
				return content.outerHTML;
			})
			.join('');

		// Create a document fragment using createContextualFragment
		const fragment = document.createRange().createContextualFragment(
			`
            ${motBoxHTML}
            <h3>MOT details and history</h3>
            <div class="mod-accordion">
                ${accordionHTML}
            </div>
            `
		);

		vehicleStatusChecker.motTabContent.appendChild(fragment);

		vehicleStatusChecker.addAccordionEListeners();
		//HIDE FORM UI
	},

	clearPriorMotResults: () => {
		if (vehicleStatusChecker.motTabContent.hasChildNodes()) {
			vehicleStatusChecker.motTabContent.innerHTML = '';
		}
	},

	addAccordionEListeners: () => {
		const accordions = document.querySelectorAll('.mod-accordion__item');

		accordions.forEach(accordionItem => {
			const item = accordionItem,
				question = accordionItem.querySelector('.mod-accordion__question'),
				answer = accordionItem.querySelector('.mod-row');

			question.addEventListener('click', () =>
				vehicleStatusChecker.toggleAccordionContent(item, question, answer)
			);
		});
	},

	resetApp: () => {
		if (vehicleStatusChecker.motTabContent.hasChildNodes()) vehicleStatusChecker.motTabContent.innerHTML = '';
		if (vehicleStatusChecker.taxTabContent.hasChildNodes()) vehicleStatusChecker.taxTabContent.innerHTML = '';

		vehicleStatusChecker.toggleUiVisibilityHelper(vehicleStatusChecker.tabSection);
		vehicleStatusChecker.toggleUiVisibilityHelper(vehicleStatusChecker.vehicleDetailsSection);
		vehicleStatusChecker.toggleUiVisibilityHelper(vehicleStatusChecker.regForm);
	},

	processMotTab: motData => {
		console.log(motData);
		const { motTests } = motData[0];

		if (motTests) {
			vehicleStatusChecker.organiseMotResults(motTests);
		} else {
			vehicleStatusChecker.showResultsNotFound(
				vehicleStatusChecker.motTabContent,
				vehicleStatusChecker.motNotFound
			);
		}
	},

	processTaxTab: taxData => {
		if (Object.keys(taxData).length) {
			const { taxStatus, taxDueDate } = taxData;
			vehicleStatusChecker.populateTaxQuoteBox(taxStatus, taxDueDate);
		} else {
			vehicleStatusChecker.showResultsNotFound(
				vehicleStatusChecker.taxTabContent,
				vehicleStatusChecker.taxNotFound
			);
		}
	},

	processVehicleDetailsSection: (motData, taxData, userReg) => {
		const { engineCapacity, monthOfFirstRegistration } = taxData || {};
		const { fuelType, model, make } = (motData && motData[0]) || {};

		let monthOfFirstRegistrationString = '';
		if (monthOfFirstRegistration) {
			const parsedMonthOfFirstRegistration = vehicleStatusChecker.parseDateTime(monthOfFirstRegistration);
			const formattedRegistrationDate = vehicleStatusChecker.formatDate(
				new Date(parsedMonthOfFirstRegistration),
				true
			);
			monthOfFirstRegistrationString = `, ${formattedRegistrationDate}`;
		}

		const makeString = make ? `${make}` : '';
		const modelString = model ? `, ${model}` : '';
		const fuelTypeString = fuelType ? `, ${fuelType}` : '';
		const engineCapacityString = engineCapacity ? `, ${engineCapacity}cc` : '';

		const vehicleDetailsString = `${makeString}${modelString}${fuelTypeString}${monthOfFirstRegistrationString}${engineCapacityString}`;
		vehicleStatusChecker.vehicleReg.innerText = userReg.toUpperCase();
		vehicleStatusChecker.vehicleDetails.innerText = vehicleDetailsString;
	},

	checkVehicleStatusData: (motData, taxData, userReg) => {
		if (!Object.keys(taxData).length && !Object.keys(motData).length) {
			//NO DATA RETURNED FROM EITHER API
			return vehicleStatusChecker.carRegNotFound();
		} else {
			vehicleStatusChecker.processMotTab(motData);
			vehicleStatusChecker.processTaxTab(taxData);
			vehicleStatusChecker.processVehicleDetailsSection(motData, taxData, userReg);

			// TOGGLE VISIBILITY OF ELEMENTS
			vehicleStatusChecker.toggleUiVisibilityHelper(vehicleStatusChecker.regForm);
			vehicleStatusChecker.toggleUiVisibilityHelper(vehicleStatusChecker.vehicleDetailsSection);
			vehicleStatusChecker.toggleUiVisibilityHelper(vehicleStatusChecker.tabSection);
		}
	},

	fetchVehicleData: async userReg => {
		let motData = {};
		let taxData = {};

		console.log('Fetching data...');

		try {
			motData = await vehicleStatusChecker.fetchDataHelper(vehicleStatusChecker.motApiUrl, userReg);
		} catch (error) {
			console.log(`MOT Error: ${error}`);
		}

		try {
			taxData = await vehicleStatusChecker.fetchDataHelper(vehicleStatusChecker.taxApiUrl, userReg);
		} catch (error) {
			console.log(`Tax Error: ${error}`);
		}

		vehicleStatusChecker.checkVehicleStatusData(motData, taxData, userReg);

		vehicleStatusChecker.isLoading = false;
		vehicleStatusChecker.submitRegButton.classList.remove('btn--loading');
	},

	fetchDataHelper: async (url, userReg) => {
		const endpoint = `${url}=${userReg}`;

		const fetchPromise = (async () => {
			const res = await sGetFromEngagementTools(vehicleStatusChecker.apiSubKey, endpoint);
			if (!res.ok) throw new Error(res.status);
			const response = await res.json();
			return response;
		})();

		// Timeout promise
		const timeoutPromise = new Promise((_, reject) => {
			setTimeout(() => reject(new Error(500)), 5000); // 5 seconds - This will be for each API call
		});

		// Race between fetch and timeout
		return Promise.race([fetchPromise, timeoutPromise]);
	},
};

document.addEventListener('DOMContentLoaded', function () {
	const motAndTaxCalc = document.getElementById('cnfsd-vsc');

	if (motAndTaxCalc) {
		vehicleStatusChecker.init();
	}
});
